import {useMemo} from "react";
import {useSelector} from "react-redux";
import { useLocation } from 'react-router-dom';
import {UserRole} from "../views/users/constant";

const RouteToConfigMap = {
  'deliveries': 'enable_deliveries',
  'security': 'enable_security_cameras',
  'security/nvr': 'enable_ai_nvr',
  'leak-detectors': 'enable_leak_detectors',
  'thermostats': 'enable_thermostats',
  'parking': 'enable_license_plates',
  'parking-analytics': 'enable_license_plates',
  'chargers': 'enable_chargers',
  'documents': 'enable_document_storage',
  'events': 'enable_events'
};

export const useGetConfigs = (props = {}) => {
  const buildingId = props?.buildingId || 0;
  const {organization} = useSelector((state) => state.Organization);
  const { building, globalSelectedBuilding, allBuildings } = useSelector((state) => state.building);
  const { roleId } = useSelector((state) => state.auth);
  const location = useLocation();

  const targetBuilding = useMemo(() => {
      if (buildingId === 0) return;
      return allBuildings?.find((b) => b.id === buildingId);
  }, [allBuildings, buildingId]);

  const config = useMemo(()=>{
    return (
      (buildingId > 0 ? targetBuilding?.config : building?.config) ||
      globalSelectedBuilding?.config ||
      organization?.config
    );
  },[
    building,
    globalSelectedBuilding,
    organization,
    buildingId,
    targetBuilding
  ]);

  const isSectionEnabled = useMemo(()=>{
    if (roleId == UserRole.SUPER_ADMIN) return true;
    const currentRoute = location?.pathname?.replace("/","");
    const configName = RouteToConfigMap[currentRoute];

    if (!Boolean(configName)) return true;
    if (Boolean(config)) return !!config[configName];

    return true;
  },[
    config,
    location,
  ]);

  return {
    config,
    orgConfig: organization?.config,
    isSectionEnabled,
  };
};

